
import { academiaMejiasApi } from "../academiaMejiasApi";

export const getColegios = async () => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.get('/public/colegios',);
        return { ok: true, colegios: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}

export const getSedesCorreosCR = async () => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.get('/public/sedecorreoscr',);
        return { ok: true, sedes: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}


export const getCursos = async () => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.get('/public/cursos',);
        return { ok: true, cursos: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}

export const getGruposByCurso = async (cursoId: string) => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.get(`/public/grupos/${cursoId}`,);
        return { ok: true, grupos: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}


